module.exports = __webpack_public_path__ + "static/media/saoaggo2.8a8581b0.png";